import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getThemesV2, unMountComponent } from '../../actions/website/ThemeActions';
import Themes from './Themes';

class ThemesContainer extends Component {
  constructor(props) {
    super(props);
    const { onboard } = this.props;
    this.state = {
      offset: 0,
      onboardActive: onboard,
      filterOptions: {},
      themeGroup: props.themeGroup,
      themeGroupTitle: props.themeGroupTitle
    };
  }

  componentDidMount() {
    const { loadThemes } = this.props;
    loadThemes(0);
  }

  componentWillUnmount() {
    const { unMountThemes } = this.props;
    unMountThemes();
  }


  render() {
    return (
      <Themes />
    );
  }
}

ThemesContainer.propTypes = {
  themeGroup: PropTypes.shape({
    themes: PropTypes.arrayOf(
      PropTypes.shape({})
    ),
  }),
  themeGroupTitle: PropTypes.string,
  loadThemes: PropTypes.func.isRequired,
  unMountThemes: PropTypes.func.isRequired,
  onboard: PropTypes.bool,
};

const mapStateToProps = state => (
  {
    themes: state.website.themeListing,
    weddingTheme: state.wedding.theme,
    onboard: !state.wedding.account.disable_website_onboarding,
    weddingSlug: state.wedding.wedding.slug,
    themeGroup: state.website.themeListing.themeDetails,
    themeGroupTitle: state.wedding.themeGroupTitle,
  }
);

const mapDispatchToProps = dispatch => (
  {
    loadThemes: (offset) => {
      dispatch(getThemesV2(offset));
    },
    unMountThemes: () => dispatch(unMountComponent()),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThemesContainer);



/** WEBPACK FOOTER **
 ** ./src/pages/preauth/ThemesContainer.jsx
 **/